<!--  -->
<template>
  <div></div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {}
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    hrefAppFn(params) {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isAndroid) {
        window.messageHandlers.hrefApp(JSON.stringify(params))
      } else {
        window.webkit.messageHandlers.hrefApp.postMessage(JSON.stringify(params))
      }
      window.history.go(-1);
    },   
    openApp() {
      var vs = this.$route.query;
      var url = vs['url'];
      for (const key in vs) {
        var element = vs[key];
        if (key == 'url' || key == 'theme' || key == 'bgcolor') {
          continue;
        }
        if (url.indexOf('?') == -1) {
          url = url + '?' + key + '=' + element
        } else if (url.indexOf('?') != -1) {
          url = url + '&' + key + '=' + element
        }
      }
      console.log(url);
      var routerId = url + '^https://android.myapp.com/myapp/detail.htm?apkName=com.jd.yyc&ADTAG=mobile';
      var params = {
        path: 'openApp',
        routerId: routerId
      }
      console.log(params);
      this.hrefAppFn(params);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.openApp();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
